var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.$store.state.loggedIn)?_c('v-main',[_c('NavBar'),_c('router-view')],1):_vm._e(),(!_vm.$store.state.loggedIn)?_c('v-main',[_c('router-view')],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }